(ns frontend.components.inputs.multiplier
  (:require
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.utils :as fu]
   [frontend.utils :as utils]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [:value :class-name :placeholder
                :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled? :base-multiplier]}
        args
        raw-value (:temp-value @dom-atom)
        edit-decimals (if (nil? raw-value) -1 (get @dom-atom :decimal-count))
        edit-value (or raw-value value)
        edit-negative? (get @dom-atom :negative?)
        ;; We break pure function here - makes using the number formatter bit easier -- TODO: should we not do this ?
        clear-state! (fn []
                       (swap! dom-atom dissoc
                         :temp-value
                         :negative?
                         :cleared?))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (str placeholder)
             :type        "text"
             :class-name  (fu/cs "component-multiplier" (when has-focus? "focus") class-name)
             :on-focus    (fn [e]
                            (.select (:input-dom-node @dom-atom)) ;; all desktop browsers - select all text
                            (when on-focus!
                              (on-focus! e)))
             :on-blur     (fn [e]
                            (when on-blur!
                              (on-blur! e edit-value clear-state!)))
             :value       (if-not has-focus?
                            (if (nil? value)
                              ""
                              (str (utils/format-with-separators value 2 false 3) "x"))
                            (let [draw-value edit-value
                                  min-decimal-count edit-decimals]
                              (or
                               (when draw-value
                                 (if (= draw-value "")
                                   (when edit-negative? "-")
                                   (utils/format-with-separators draw-value min-decimal-count edit-negative? 3))) ;; append decimal when editing without decimals
                               "")))
             :on-key-down on-key-down!
             :on-change   (fn [e]
                            (let [input (-> e
                                            .-target
                                            .-value)
                                  float-value (utils/parse-float-info input "")]
                              (swap! dom-atom assoc
                                :decimal-count (or (:decimal-count float-value) -1)
                                :negative? (or (:negative? float-value) false)
                                :temp-value (:float-value float-value))
                              (when on-change!
                                (on-change! e (:float-value float-value)))))}
            (when disabled?
              {:disabled (boolean disabled?)}))]))


(defmethod editor :editor.type/multiplier
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "multiplier"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/multiplier
  [args]
  (fu/format-multiplier (:value args)))

(defn preview
  "The read-only text of a multiplier: a number with 3 decimals and the unit. The
   old icon `fa-multiplier` has no glyph in Font Awesome 6, so the text carries the
   unit."
  [{:keys [value]}]
  [:div.preview.preview-multiplier
   (fu/format-multiplier value)])

(defmethod viewer :editor.type/multiplier
  [args]
  (r/create-class
   {:display-name   "multiplier/viewer"
    :reagent-render preview}))
